import { ReactTyped } from "react-typed";

const phrases = [
    "Proactive UMKC student in search of new knowledge studying computer science.",
    "Active GoDot game developer.",
    "Past Combat Robotics Media Lead for MST.",
    "React developer who wrote this website.",
    "Artist and Photographer.",
    "Always learning, always building — from web apps to robots.",
    "Curious by default, technical by training, creative by instinct."
  ];

  function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

export default function TypingBanner() {
    const shuffledPhrases = shuffleArray(phrases);
    return(
    <ReactTyped
              strings={shuffledPhrases}
              typeSpeed={40}
              backDelay={1000}
              loop
            ></ReactTyped>)
  }
